import React from 'react';
import { Select } from 'antd';
import i18next from 'i18next';

const { Option } = Select;

export const LanguageSwitch = () => {
  const language = i18next.language;

  const changeLanguage = (value: string) => {
    i18next.changeLanguage(value);
  };

  return (
    <Select size="small" value={language} style={{ marginRight: 20, fontSize: 12 }} onChange={changeLanguage}>
      <Option style={{ fontSize: 12 }} value="nl-BE">
        NL
      </Option>
      <Option style={{ fontSize: 12 }} value="fr-BE">
        FR
      </Option>
      <Option style={{ fontSize: 12 }} value="en-BE">
        EN
      </Option>
    </Select>
  );
};
